import { Button } from 'components';
import './Modal-confirmation.scss';

interface ModalConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

export const ModalConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isLoading = false,
}: ModalConfirmationProps) => {
  if (!isOpen) return null;

  return (
    <div className="modal-confirmation__overlay">
      <div className="modal-confirmation__container">
        <div className="modal-confirmation__content">
          <h3 className="modal-confirmation__title">{title}</h3>
          <p className="modal-confirmation__message">{message}</p>
          <div className="modal-confirmation__actions">
            <Button
              template="secondary"
              typeStyle="square"
              color="primary"
              size="small"
              onClick={onClose}
              isDisabled={isLoading}
            >
              {cancelText}
            </Button>
            <Button
              template="primary"
              typeStyle="square"
              color="primary"
              size="small"
              onClick={onConfirm}
              isLoading={isLoading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
